import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            registration_fields: {
              tab_name: 'TAB_NAME',
              label: 'LABEL',
            },
          },
        },
      },
    },
  }));
}
